<template>
  <image-tile
    @tile-clicked="tileClicked"
    :edit-enabled="project.isEditModeEnabled"
  >
    <template v-slot:image>
      <font-awesome-icon icon="image" size="6x" class="text-black-50" />
    </template>
    <template v-slot:line1>
      <p>
        <font-awesome-icon
          icon="circle"
          :class="[snapshot.id === $store.state.snapshot.currentSnapshot.id
            ? 'text-success'
            : 'text-black-25'
          ]"
        />
        {{ snapshot.name }}
      </p>
    </template>
  </image-tile>
</template>

<script>
import { mapState } from 'vuex';
import ImageTile from '@/components/utils/tiles/ImageTile';

export default {
  name: 'SnapshotTile',
  props: {
    snapshot: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('app', [
      'project',
    ]),
  },
  methods: {
    tileClicked() {
      this.$emit('tile-clicked');
    },
  },
  components: { ImageTile },
};
</script>

<style scoped>

</style>
